import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { privacyPolicyAPI } from '../../services/api';

interface PrivacyPolicyState {
  content: string;
  loading: boolean;
  error: string | null;
  saved: boolean;
}

const initialState: PrivacyPolicyState = {
  content: '',
  loading: false,
  error: null,
  saved: false,
};

// Async thunk for fetching privacy policy
export const fetchPrivacyPolicy = createAsyncThunk(
  'privacyPolicy/fetchPrivacyPolicy',
  async () => {
    const response = await privacyPolicyAPI.getPrivacyPolicy();
    console.log('Fetched privacy policy:', response);
    return response.data.text;
  }
);

// Async thunk for saving privacy policy
export const savePrivacyPolicy = createAsyncThunk(
  'privacyPolicy/savePrivacyPolicy',
  async (content: string) => {
    const response = await privacyPolicyAPI.updatePrivacyPolicy(content);
    return response.data.text;
  }
);

const privacyPolicySlice = createSlice({
  name: 'privacyPolicy',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    clearSaved: (state) => {
      state.saved = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch privacy policy
      .addCase(fetchPrivacyPolicy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
      })
      .addCase(fetchPrivacyPolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch privacy policy';
      })
      // Save privacy policy
      .addCase(savePrivacyPolicy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePrivacyPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
        state.saved = true;
      })
      .addCase(savePrivacyPolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to save privacy policy';
      });
  },
});

export const { setContent, clearSaved, clearError } = privacyPolicySlice.actions;
export default privacyPolicySlice.reducer; 